"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var createIconComponent = function createIconComponent(_ref) {
  var content = _ref.content,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '70' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '70' : _ref$width;
  return function (props) {
    return _react["default"].createElement("svg", _extends({}, props, {
      className: "svg-icon ".concat(props.className !== '' ? props.className : ''),
      viewBox: "0 0 ".concat(width, " ").concat(height)
    }), content);
  };
};

var _default = createIconComponent;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/utils/createIconComponent.js
// module id = 6
// module chunks = 0